// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-axios';
import type {
  AddChatMessageV1ChatAddChatMessagePostData,
  AddChatMessageV1ChatAddChatMessagePostError,
  AddChatMessageV1ChatAddChatMessagePostResponse,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError,
  AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse,
  AnswerToTextV1ChatAnswerToTextPostData,
  AnswerToTextV1ChatAnswerToTextPostError,
  AnswerToTextV1ChatAnswerToTextPostResponse,
  GetAntonymsV1WordInfoAntonymsGetData,
  GetAntonymsV1WordInfoAntonymsGetError,
  GetAntonymsV1WordInfoAntonymsGetResponse,
  GetArticleV1FeedsSummaryTopicIdGetData,
  GetArticleV1FeedsSummaryTopicIdGetError,
  GetArticleV1FeedsSummaryTopicIdGetResponse,
  GetArticleV1KlexikonArticlesTitleGetData,
  GetArticleV1KlexikonArticlesTitleGetError,
  GetArticleV1KlexikonArticlesTitleGetResponse,
  GetArticleV1WordInfoArticleGetData,
  GetArticleV1WordInfoArticleGetError,
  GetArticleV1WordInfoArticleGetResponse,
  GetAutoTextV1AutoTextPostData,
  GetAutoTextV1AutoTextPostError,
  GetAutoTextV1AutoTextPostResponse,
  GetBookContentV1BooksContentBookUrlGetData,
  GetBookContentV1BooksContentBookUrlGetError,
  GetBookContentV1BooksContentBookUrlGetResponse,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError,
  GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse,
  GetConfigV1ConfigGetError,
  GetConfigV1ConfigGetResponse,
  GetConjugationsV1WordInfoConjugationsGetData,
  GetConjugationsV1WordInfoConjugationsGetError,
  GetConjugationsV1WordInfoConjugationsGetResponse,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetData,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetError,
  GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse,
  GetDefinitionV1WordInfoDefinitionGetData,
  GetDefinitionV1WordInfoDefinitionGetError,
  GetDefinitionV1WordInfoDefinitionGetResponse,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError,
  GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse,
  GetExampleSentenceV1WordInfoExampleSentencePostData,
  GetExampleSentenceV1WordInfoExampleSentencePostError,
  GetExampleSentenceV1WordInfoExampleSentencePostResponse,
  GetExampleV1WordInfoExampleGetData,
  GetExampleV1WordInfoExampleGetError,
  GetExampleV1WordInfoExampleGetResponse,
  GetExamplesV1WordInfoExamplesGetData,
  GetExamplesV1WordInfoExamplesGetError,
  GetExamplesV1WordInfoExamplesGetResponse,
  GetExtensionsV1WordInfoExtensionsGetData,
  GetExtensionsV1WordInfoExtensionsGetError,
  GetExtensionsV1WordInfoExtensionsGetResponse,
  GetGrammerV1WordInfoGrammerGetData,
  GetGrammerV1WordInfoGrammerGetError,
  GetGrammerV1WordInfoGrammerGetResponse,
  GetHeadlineByIdV1FeedsIdGetData,
  GetHeadlineByIdV1FeedsIdGetError,
  GetHeadlineByIdV1FeedsIdGetResponse,
  GetHeadlineByIdxV1FeedsGetData,
  GetHeadlineByIdxV1FeedsGetError,
  GetHeadlineByIdxV1FeedsGetResponse,
  GetImageSentenceV1WordInfoImageSentenceGetData,
  GetImageSentenceV1WordInfoImageSentenceGetError,
  GetImageSentenceV1WordInfoImageSentenceGetResponse,
  GetImageV1WordInfoImageGetData,
  GetImageV1WordInfoImageGetError,
  GetImageV1WordInfoImageGetResponse,
  GetImagesUnsplashV1WordInfoImagesGetData,
  GetImagesUnsplashV1WordInfoImagesGetError,
  GetImagesUnsplashV1WordInfoImagesGetResponse,
  GetLoadCountsV1ConfigLoadCountsGetData,
  GetLoadCountsV1ConfigLoadCountsGetError,
  GetLoadCountsV1ConfigLoadCountsGetResponse,
  GetMainTranslationsV1WordInfoMainTranslationsGetData,
  GetMainTranslationsV1WordInfoMainTranslationsGetError,
  GetMainTranslationsV1WordInfoMainTranslationsGetResponse,
  GetMappingsV1WordInfoMappingsGetData,
  GetMappingsV1WordInfoMappingsGetError,
  GetMappingsV1WordInfoMappingsGetResponse,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetData,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetError,
  GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse,
  GetSynonymsV1WordInfoSynonymsGetData,
  GetSynonymsV1WordInfoSynonymsGetError,
  GetSynonymsV1WordInfoSynonymsGetResponse,
  GetTeasersV1KlexikonTeasersGetData,
  GetTeasersV1KlexikonTeasersGetError,
  GetTeasersV1KlexikonTeasersGetResponse,
  GetTextCorrectionV1WriteCorrectPostData,
  GetTextCorrectionV1WriteCorrectPostError,
  GetTextCorrectionV1WriteCorrectPostResponse,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetData,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetError,
  GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse,
  GetTranslationV1WordInfoTranslationGetData,
  GetTranslationV1WordInfoTranslationGetError,
  GetTranslationV1WordInfoTranslationGetResponse,
  GetVideoByIdV1VideosIdGetData,
  GetVideoByIdV1VideosIdGetError,
  GetVideoByIdV1VideosIdGetResponse,
  GetVideoByIdxV1VideosChannelChannelIdGetData,
  GetVideoByIdxV1VideosChannelChannelIdGetError,
  GetVideoByIdxV1VideosChannelChannelIdGetResponse,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError,
  GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse,
  ReturnAudioFileV1FileAudioLangExtQgetData,
  ReturnAudioFileV1FileAudioLangExtQgetError,
  ReturnAudioFileV1FileAudioLangExtQgetResponse,
  ReturnImageFileV1FileImageNameGetData,
  ReturnImageFileV1FileImageNameGetError,
  ReturnImageFileV1FileImageNameGetResponse,
  SendEmailV1EmailSendPostData,
  SendEmailV1EmailSendPostError,
  SendEmailV1EmailSendPostResponse,
  SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetData,
  SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetError,
  SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetResponse
} from './types.gen';

export const client = createClient(createConfig());

export class WordInfoService {
  /**
   *  Get Translation
   */
  public static getTranslationV1WordInfoTranslationGet<ThrowOnError extends boolean = false>(
    options: Options<GetTranslationV1WordInfoTranslationGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetTranslationV1WordInfoTranslationGetResponse,
      GetTranslationV1WordInfoTranslationGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translation'
    });
  }

  /**
   *  Get Translation Sentence
   */
  public static getTranslationSentenceV1WordInfoTranslationSentenceGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetTranslationSentenceV1WordInfoTranslationSentenceGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse,
      GetTranslationSentenceV1WordInfoTranslationSentenceGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/translation-sentence'
    });
  }

  /**
   *  Get Image
   */
  public static getImageV1WordInfoImageGet<ThrowOnError extends boolean = false>(
    options: Options<GetImageV1WordInfoImageGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImageV1WordInfoImageGetResponse,
      GetImageV1WordInfoImageGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/image'
    });
  }

  /**
   *  Get Example
   */
  public static getExampleV1WordInfoExampleGet<ThrowOnError extends boolean = false>(
    options: Options<GetExampleV1WordInfoExampleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExampleV1WordInfoExampleGetResponse,
      GetExampleV1WordInfoExampleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/example'
    });
  }

  /**
   *  Get Examples
   */
  public static getExamplesV1WordInfoExamplesGet<ThrowOnError extends boolean = false>(
    options: Options<GetExamplesV1WordInfoExamplesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExamplesV1WordInfoExamplesGetResponse,
      GetExamplesV1WordInfoExamplesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/examples'
    });
  }

  /**
   *  Get Emotional Examples
   */
  public static getEmotionalExamplesV1WordInfoEmotionalExamplesGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse,
      GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/emotional-examples'
    });
  }

  /**
   *  Get Images Unsplash
   */
  public static getImagesUnsplashV1WordInfoImagesGet<ThrowOnError extends boolean = false>(
    options: Options<GetImagesUnsplashV1WordInfoImagesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImagesUnsplashV1WordInfoImagesGetResponse,
      GetImagesUnsplashV1WordInfoImagesGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/images'
    });
  }

  /**
   *  Get Synonyms
   */
  public static getSynonymsV1WordInfoSynonymsGet<ThrowOnError extends boolean = false>(
    options: Options<GetSynonymsV1WordInfoSynonymsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetSynonymsV1WordInfoSynonymsGetResponse,
      GetSynonymsV1WordInfoSynonymsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/synonyms'
    });
  }

  /**
   *  Get Antonyms
   */
  public static getAntonymsV1WordInfoAntonymsGet<ThrowOnError extends boolean = false>(
    options: Options<GetAntonymsV1WordInfoAntonymsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAntonymsV1WordInfoAntonymsGetResponse,
      GetAntonymsV1WordInfoAntonymsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/antonyms'
    });
  }

  /**
   *  Get Main Translations
   */
  public static getMainTranslationsV1WordInfoMainTranslationsGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetMainTranslationsV1WordInfoMainTranslationsGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetMainTranslationsV1WordInfoMainTranslationsGetResponse,
      GetMainTranslationsV1WordInfoMainTranslationsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/main-translations'
    });
  }

  /**
   *  Get Extensions
   */
  public static getExtensionsV1WordInfoExtensionsGet<ThrowOnError extends boolean = false>(
    options: Options<GetExtensionsV1WordInfoExtensionsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetExtensionsV1WordInfoExtensionsGetResponse,
      GetExtensionsV1WordInfoExtensionsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/extensions'
    });
  }

  /**
   *  Get Mappings
   */
  public static getMappingsV1WordInfoMappingsGet<ThrowOnError extends boolean = false>(
    options: Options<GetMappingsV1WordInfoMappingsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetMappingsV1WordInfoMappingsGetResponse,
      GetMappingsV1WordInfoMappingsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/mappings'
    });
  }

  /**
   *  Get Definition
   */
  public static getDefinitionV1WordInfoDefinitionGet<ThrowOnError extends boolean = false>(
    options: Options<GetDefinitionV1WordInfoDefinitionGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetDefinitionV1WordInfoDefinitionGetResponse,
      GetDefinitionV1WordInfoDefinitionGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/definition'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1WordInfoArticleGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1WordInfoArticleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1WordInfoArticleGetResponse,
      GetArticleV1WordInfoArticleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/article'
    });
  }

  /**
   *  Get Conjugations
   */
  public static getConjugationsV1WordInfoConjugationsGet<ThrowOnError extends boolean = false>(
    options: Options<GetConjugationsV1WordInfoConjugationsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetConjugationsV1WordInfoConjugationsGetResponse,
      GetConjugationsV1WordInfoConjugationsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/conjugations'
    });
  }

  /**
   *  Get Grammer
   */
  public static getGrammerV1WordInfoGrammerGet<ThrowOnError extends boolean = false>(
    options: Options<GetGrammerV1WordInfoGrammerGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetGrammerV1WordInfoGrammerGetResponse,
      GetGrammerV1WordInfoGrammerGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/grammer'
    });
  }

  /**
   *  Get Image Sentence
   */
  public static getImageSentenceV1WordInfoImageSentenceGet<ThrowOnError extends boolean = false>(
    options: Options<GetImageSentenceV1WordInfoImageSentenceGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetImageSentenceV1WordInfoImageSentenceGetResponse,
      GetImageSentenceV1WordInfoImageSentenceGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/image-sentence'
    });
  }

  /**
   *  Get Most Common Words
   */
  public static getMostCommonWordsV1WordInfoMostCommonWordsGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetMostCommonWordsV1WordInfoMostCommonWordsGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse,
      GetMostCommonWordsV1WordInfoMostCommonWordsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/most-common-words'
    });
  }

  /**
   *  Get Example Sentence
   */
  public static getExampleSentenceV1WordInfoExampleSentencePost<
    ThrowOnError extends boolean = false
  >(options: Options<GetExampleSentenceV1WordInfoExampleSentencePostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GetExampleSentenceV1WordInfoExampleSentencePostResponse,
      GetExampleSentenceV1WordInfoExampleSentencePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/word-info/example-sentence'
    });
  }
}

export class FileService {
  /**
   * Return Audio File
   */
  public static returnAudioFileV1FileAudioLangExtQGet<ThrowOnError extends boolean = false>(
    options: Options<ReturnAudioFileV1FileAudioLangExtQgetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReturnAudioFileV1FileAudioLangExtQgetResponse,
      ReturnAudioFileV1FileAudioLangExtQgetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/audio/{lang}/{ext}/{q}'
    });
  }

  /**
   * Return Image File
   */
  public static returnImageFileV1FileImageNameGet<ThrowOnError extends boolean = false>(
    options: Options<ReturnImageFileV1FileImageNameGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReturnImageFileV1FileImageNameGetResponse,
      ReturnImageFileV1FileImageNameGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/file/image/{name}'
    });
  }
}

export class SentencesService {
  /**
   * Split Chinese Sentence
   */
  public static splitChineseSentenceV1SentencesSplitChineseSentenceStentenceGet<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetResponse,
      SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/sentences/split-chinese-sentence/{stentence}'
    });
  }
}

export class ConfigService {
  /**
   * Get Config
   */
  public static getConfigV1ConfigGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetConfigV1ConfigGetResponse,
      GetConfigV1ConfigGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/config/'
    });
  }

  /**
   * Get Load Counts
   */
  public static getLoadCountsV1ConfigLoadCountsGet<ThrowOnError extends boolean = false>(
    options: Options<GetLoadCountsV1ConfigLoadCountsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetLoadCountsV1ConfigLoadCountsGetResponse,
      GetLoadCountsV1ConfigLoadCountsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/config/load-counts'
    });
  }
}

export class FeedsService {
  /**
   *  Get Headline By Idx
   */
  public static getHeadlineByIdxV1FeedsGet<ThrowOnError extends boolean = false>(
    options: Options<GetHeadlineByIdxV1FeedsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetHeadlineByIdxV1FeedsGetResponse,
      GetHeadlineByIdxV1FeedsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/'
    });
  }

  /**
   *  Get Headline By Id
   */
  public static getHeadlineByIdV1FeedsIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetHeadlineByIdV1FeedsIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetHeadlineByIdV1FeedsIdGetResponse,
      GetHeadlineByIdV1FeedsIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/{id}'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1FeedsSummaryTopicIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1FeedsSummaryTopicIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1FeedsSummaryTopicIdGetResponse,
      GetArticleV1FeedsSummaryTopicIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/feeds/summary/{topic}/{id}'
    });
  }
}

export class VideosService {
  /**
   *  Get Video By Idx
   */
  public static getVideoByIdxV1VideosChannelChannelIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetVideoByIdxV1VideosChannelChannelIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetVideoByIdxV1VideosChannelChannelIdGetResponse,
      GetVideoByIdxV1VideosChannelChannelIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/videos/channel/{channel_id}'
    });
  }

  /**
   *  Get Video By Id
   */
  public static getVideoByIdV1VideosIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetVideoByIdV1VideosIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetVideoByIdV1VideosIdGetResponse,
      GetVideoByIdV1VideosIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/videos/{id}'
    });
  }
}

export class KlexikonService {
  /**
   *  Get Teasers
   */
  public static getTeasersV1KlexikonTeasersGet<ThrowOnError extends boolean = false>(
    options: Options<GetTeasersV1KlexikonTeasersGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetTeasersV1KlexikonTeasersGetResponse,
      GetTeasersV1KlexikonTeasersGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/klexikon/teasers'
    });
  }

  /**
   *  Get Article
   */
  public static getArticleV1KlexikonArticlesTitleGet<ThrowOnError extends boolean = false>(
    options: Options<GetArticleV1KlexikonArticlesTitleGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetArticleV1KlexikonArticlesTitleGetResponse,
      GetArticleV1KlexikonArticlesTitleGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/klexikon/articles/{title}'
    });
  }
}

export class BooksService {
  /**
   * Get Book Content
   */
  public static getBookContentV1BooksContentBookUrlGet<ThrowOnError extends boolean = false>(
    options: Options<GetBookContentV1BooksContentBookUrlGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBookContentV1BooksContentBookUrlGetResponse,
      GetBookContentV1BooksContentBookUrlGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/books/content/{book_url}'
    });
  }
}

export class ChatService {
  /**
   * Answer To Text
   */
  public static answerToTextV1ChatAnswerToTextPost<ThrowOnError extends boolean = false>(
    options: Options<AnswerToTextV1ChatAnswerToTextPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AnswerToTextV1ChatAnswerToTextPostResponse,
      AnswerToTextV1ChatAnswerToTextPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/answer-to-text'
    });
  }

  /**
   * Add Chat Message
   */
  public static addChatMessageV1ChatAddChatMessagePost<ThrowOnError extends boolean = false>(
    options: Options<AddChatMessageV1ChatAddChatMessagePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddChatMessageV1ChatAddChatMessagePostResponse,
      AddChatMessageV1ChatAddChatMessagePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/add-chat-message'
    });
  }

  /**
   * Answer To Conversation
   */
  public static answerToConversationV1ChatAnswerToConversationMainCategoryCategoryPost<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse,
      AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/chat/answer-to-conversation/{main_category}/{category}'
    });
  }
}

export class CategoryService {
  /**
   * Get Conversations
   */
  public static getConversationsV1CategoryConversationsMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(
    options: Options<
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse,
      GetConversationsV1CategoryConversationsMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/conversations/{main_category}/{category}'
    });
  }

  /**
   *  Get Write Task
   */
  public static getWriteTaskV1CategoryWriteMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse,
      GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/write/{main_category}/{category}'
    });
  }

  /**
   * Get Category
   */
  public static getCategoryV1CategoryCategoryTypeMainCategoryCategoryGet<
    ThrowOnError extends boolean = false
  >(options: Options<GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse,
      GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/category/{category_type}/{main_category}/{category}'
    });
  }
}

export class EmailService {
  /**
   *  Send Email
   * Send a email.
   */
  public static sendEmailV1EmailSendPost<ThrowOnError extends boolean = false>(
    options: Options<SendEmailV1EmailSendPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SendEmailV1EmailSendPostResponse,
      SendEmailV1EmailSendPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/email/send'
    });
  }
}

export class AutoTextService {
  /**
   * Get Auto Text
   */
  public static getAutoTextV1AutoTextPost<ThrowOnError extends boolean = false>(
    options: Options<GetAutoTextV1AutoTextPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetAutoTextV1AutoTextPostResponse,
      GetAutoTextV1AutoTextPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auto-text/'
    });
  }
}

export class WriteService {
  /**
   *  Get Text Correction
   */
  public static getTextCorrectionV1WriteCorrectPost<ThrowOnError extends boolean = false>(
    options: Options<GetTextCorrectionV1WriteCorrectPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      GetTextCorrectionV1WriteCorrectPostResponse,
      GetTextCorrectionV1WriteCorrectPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/write/correct'
    });
  }
}
